export default "__VITE_ASSET__2eaee7f2__"